module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAYAAABPeYUaAAABRUlEQVQ4T63TPUvDUBQG4Pe9NTEKQncnB4vgLk7+izg4pTQfU6E4OYi2g+AkSqeSFuPiYH6I4g8QaYcuzqXgYEzoPRIhHSrVCr3zuc/5uOcyCIIDEYkAbOH/Z0jSoed5A5IPInKvlJJFHa01SR6JyGGOaAA7YRj2FwWKOM/zKgBe6fu+kKyMRqO3OI4/FoV8318nuSki/W8ky7JdwzAeAYRpmp5GUZTMwxzHsQzDuCDpaq33lVIv00pEZAPAHYAVrXW12+0+zUKu6+aXbgFkAByS79NK8nY6nc7Atm2zXC43SR6LyLVlWeftdvuzXq+vJknSItkQkavxeNyM4zgNgmD7B1JkrtVqe6VSKc8oWutLpdQJAE4mk2qv13su4n5F8qC8d9M0WwAaAG7SND2bndWfSJHNtu21ea82RZayJ0vZ2GX8nS/raMe5pLbeyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/email_icon.png
// module id = z1CC
// module chunks = 1